import preLaunchReducer from './reducer';

export default preLaunchReducer;
